export const EMAIL_ERRORS = {
  REQUIRED: 'required',
  CHECK_EMAIL: 'checkEmail',
};

export const emailValidationRegexStr =
  "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?";

export function validateEmail(email) {
  return new RegExp(emailValidationRegexStr, 'ig').test(email);
}

export function validateEmailWithErrors(email) {
  const currentErrors = [];

  if (!email) {
    currentErrors.push(EMAIL_ERRORS.REQUIRED);
  }

  if (!validateEmail(email)) {
    currentErrors.push(EMAIL_ERRORS.CHECK_EMAIL);
  }

  return {
    isValid: currentErrors.length === 0,
    errors: currentErrors,
  };
}
